import { useSelector } from 'react-redux';
import {
    Redirect,
    Route,
} from 'react-router-dom';
import { isLoggedIn } from '../../store/auth/selectors';

function ProtectedRoute({ children, ...rest }) {
    const loggedIn = useSelector(isLoggedIn);

    return (
        <Route
            {...rest}
            render={() => 
                loggedIn === true ? (
                    children
                ) : (
                    <Redirect to="/login" />
                )
            } 
        />
    )
}

export default ProtectedRoute;